import React from 'react'

import Collapsible from "react-collapsible";

import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";

import Border from "./Border";
import Toggle from "./sectioninputs/Toggle";
import Dropdown from "./Dropdown";
import {renderDragIcon} from "../utils/renderDragIcon.js"
import ColorPicker from './ColorPicker.js';
import { getDefaultButtonStyles, CART_DRAWER_BUTTON_COLOR_CONSTANTS } from './constants/utils.js';

export default class DrawerCartSettings extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      data: props.data,
    }

  }

  componentDidMount() {

  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderButtonStyles(buttonType, buttonStyle){
    let { data } = this.state;
    const defaultStyles = getDefaultButtonStyles(buttonStyle);
    return (
      <>
        {
          CART_DRAWER_BUTTON_COLOR_CONSTANTS.map((item, index) => {
            const styleKey = `${buttonType}_${item.key}`;
            return <ColorPicker
              key={index}
              title={item.label}
              color={data?.[styleKey] || defaultStyles[item.key]}
              onColorSelected={(color) => {
                data[styleKey] = color;
                this.props.onUpdated(data)
              }}
            />
          })
        }
      </>
    )
  }

  _renderCheckoutButtonSettings(){
    let { data } = this.state

    let showCheckoutButtonInCartDrawer = data.cart_drawer_checkout ?? true
    let checkoutButtonStyle = data.cart_drawer_checkout_style || "primary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showCheckoutButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="checkout_toggle"
                checked={showCheckoutButtonInCartDrawer}
                title="Checkout Button"
                onChange={checked => {
                  data.cart_drawer_checkout = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          {this._renderButtonStyles("cart_drawer_checkout", checkoutButtonStyle)}
        </Collapsible>
      </>
    )
  }

  _renderViewCartButtonSettings(){
    let { data } = this.state

    let showViewCartButtonInCartDrawer = data.cart_drawer_view_cart ?? false
    let viewCartButtonStyle = data.cart_drawer_view_cart_style || "primary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showViewCartButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="view_cart_toggle"
                checked={showViewCartButtonInCartDrawer}
                title="View Cart Button"
                onChange={checked => {
                  data.cart_drawer_view_cart = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          {this._renderButtonStyles("cart_drawer_view_cart", viewCartButtonStyle)}
        </Collapsible>
      </>
    )
  }

  _renderContinueShoppingButtonSettings(){
    let { data } = this.state

    let showContinueShoppingButtonInCartDrawer = data.cart_drawer_continue_shopping ?? true
    let continueShoppingButtonStyle = data.cart_drawer_continue_shopping_style || "secondary"

    return (
      <>
        <Collapsible
          className={"drawer-cart-settings"}
          openedClassName={"drawer-cart-settings"}
          key={"key_+"+showContinueShoppingButtonInCartDrawer}
          trigger={
            <>
              {renderDragIcon({}, "absolute")}
              <Toggle
                id="continue_shopping_toggle"
                checked={showContinueShoppingButtonInCartDrawer}
                title="Continue Shopping Button"
                onChange={checked => {
                  data.cart_drawer_continue_shopping = checked
                  this.props.onUpdated(data)
                }}
              />
            </>
          }
        >
          <br/>
          {this._renderButtonStyles("cart_drawer_continue_shopping", continueShoppingButtonStyle)}
        </Collapsible>
      </>
    )
  }

  _onDragEnd(result, unorderedItems) {
    let { data } = this.state

    if (!result.destination) {
      return;
    }

    const items = reorder(
      unorderedItems,
      result.source.index,
      result.destination.index
    );

    items.forEach((item, index) => {
      data[item.key] = index
    })

    this.props.onUpdated(data)
  }

  render() {

    let { data } = this.state

    const buttons = [
      {
        key: "cart_drawer_checkout_position",
        position: data.cart_drawer_checkout_position ?? 0,
      },
      {
        key: "cart_drawer_view_cart_position",
        position: data.cart_drawer_view_cart_position ?? 1,
      },
      {
        key: "cart_drawer_continue_shopping_position",
        position: data.cart_drawer_continue_shopping_position ?? 2,
      }
    ]

    const orderedButtons = [...buttons].sort((a, b) => a.position - b.position);

    return (
      <>
        <Border>
          <Collapsible
            trigger={`Drawer Cart Buttons`}
          >
            <br/>
            <DragDropContext onDragEnd={(result) => this._onDragEnd(result, orderedButtons)}>
              <Droppable droppableId="cart-drawer-settings">
                {(provided, snapshot) => (
                  <div
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}
                  >
                    {
                      orderedButtons.map((button, index) => (
                        <Draggable key={button.key} draggableId={button.key} index={index}>
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {button.key === "cart_drawer_checkout_position" && this._renderCheckoutButtonSettings()}
                              {button.key === "cart_drawer_view_cart_position" && this._renderViewCartButtonSettings()}
                              {button.key === "cart_drawer_continue_shopping_position" && this._renderContinueShoppingButtonSettings()}
                            </div>
                          )}
                        </Draggable>
                      ))
                    }
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </Collapsible>
        </Border>
      </>
    )
  }
}

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 0;

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "#fbfbfb" : "transparent",
  padding: grid,
});

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: "none",
  padding: grid,
  background: isDragging ? "rgba(93, 120, 255, 0.4)" : "transparent",
  outline: "none",
  ...draggableStyle,
});
